// Impressum body — § 5 DDG provider identification plus the standard
// liability / links / copyright disclaimers. Rendered inside the info
// popup's impressum view (URL /impressum).
export default function ImpressumContent() {
  return (
    <>
      <div className="help-modal__section">
        <h3>Angaben gemäß § 5 DDG</h3>
        <p>
          Mike Rodden<br />
          Knobelsdorfstraße 89<br />
          14059 Berlin<br />
          Deutschland
        </p>
      </div>

      <div className="help-modal__section">
        <h3>Kontakt</h3>
        <p>
          E-Mail: <a href="mailto:mikerodden5@gmail.com">mikerodden5@gmail.com</a>
        </p>
      </div>

      <div className="help-modal__section">
        <h3>Verantwortlich für den Inhalt nach § 18 Abs. 2 MStV</h3>
        <p>Mike Rodden, Anschrift wie oben.</p>
      </div>

      <div className="help-modal__section">
        <h3>Liability for content</h3>
        <p>
          This site is a personal, non-commercial study tool and is not
          monetized in any way. The content has been compiled with care,
          but I cannot guarantee its accuracy, completeness, or
          topicality.
        </p>
      </div>

      <div className="help-modal__section">
        <h3>Liability for links</h3>
        <p>
          External links lead to content provided by third parties, who
          are solely responsible for it. I checked the linked pages for
          legal issues at the time of linking and found none. Should I
          learn of any violation, I will remove the affected link without
          delay.
        </p>
      </div>

      <div className="help-modal__section">
        <h3>Copyright</h3>
        <p>
          This site is a personal study project, built purely out of love
          of wine and the desire to learn. I made it while preparing for
          wine certifications, and it exists for learning only: no ads,
          no paywalls, nothing for sale.
        </p>
        <p>
          In that spirit, I claim no copyright over anything here. Not
          the data, not the design, not the code or the interface.
          Whatever I&rsquo;ve made myself, you&rsquo;re welcome to use
          freely. All third-party data remains the property of its
          respective rights holders, who are credited in the app under
          &ldquo;Data, Sources &amp; Attributions&rdquo;.
        </p>
        <p>
          If you believe anything on this site infringes your rights,
          please contact me and I&rsquo;ll remove or correct it
          immediately, no questions asked.
        </p>
      </div>
    </>
  );
}
